import React from "react";

import { Tab, Tabs, makeStyles } from "@material-ui/core";

import { LearnersTableTabsProps } from "./types";

import { useTealium } from "@hubcapp/context";

const useStyles = makeStyles(theme => ({
  root: {
    display: "block",
    width: "100%",
    paddingTop: theme.spacing(2),
  },
  flexContainer: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
}));

const LearnersTableTabs: React.FC<LearnersTableTabsProps> = ({
  value = 0,
  onValueChange = () => {},
}) => {
  const classes = useStyles();
  const { trackEvent } = useTealium();

  return (
    <Tabs
      value={value}
      onChange={(e, value) => {
        onValueChange(value);
      }}
      indicatorColor="primary"
      textColor="primary"
      classes={classes}
      onClick={() => {
        trackEvent({
          eventCategory: "Learners",
          eventAction: "Interaction",
          eventLabel: `${value ? "Active" : "Inactive"} Learner`,
        });
      }}
    >
      <Tab label="Active" data-test="show-active-learners-tab"></Tab>
      <Tab label="Inactive" data-test="show-inactive-learners-tab"></Tab>
    </Tabs>
  );
};

export default LearnersTableTabs;
